import React from 'react';
import { useState, useEffect } from 'react';
import ContractorTableHead from './contractorTableHeader';
import Scrollbar from '../../../Scrollbar';
import ContractorTableRow from './contractorTableRow';
import { useDispatch, useSelector } from 'react-redux'
import { getContractorWatcher } from '../../../../redux/actionCreators/admin/contractorManagement';
// material
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Pagination,
    Typography,
    Box
} from '@mui/material';
import { getDropDownWatcher } from '../../../../redux/actionCreators/admin/employeeManagement';

const TABLE_HEAD = [
    { id: 'NID', label: 'ID Number', alignRight: false },
    { id: 'cUserName', label: 'User Name', alignRight: false },
    { id: 'CCONTRACTORID', label: 'Contractor ID', alignRight: false },
    { id: 'CCONTRACTORNAME', label: 'Contractor Name', alignRight: false },
    { id: 'CCONTRACTORDESC', label: 'Contractor Desc', alignRight: false },
    { id: 'CCONTRACTORADDRESS', label: 'Contractor Address', alignRight: false },
];


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
}

const ContractorManagementTable = ({searchVal, searchText, page, setPage}) => {

    let firstIndex = 0;

    const dispatch = useDispatch();
    const { ContractorReducers: { contractorList }, UserHomeReducers: { cafeteriaId }, } = useSelector((state) => state)

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [rowsPerPage] = useState(5);

    useEffect(() => {
        if(cafeteriaId){
            let data = { ACTION: "SELECT", SDIVISIONID: cafeteriaId }
            dispatch(getContractorWatcher(data))
        }
    }, [dispatch, cafeteriaId])

    useEffect(()=>{
        dispatch(getDropDownWatcher())
    },[dispatch])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const tableData =  searchText ? searchVal : contractorList
    const filteredData = applySortFilter(tableData, getComparator(order, orderBy), '');
    const isUserNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 800, overflow: 'unset' }}>
                        <Table>
                            <ContractorTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                //   rowCount={USERLIST.length}
                                //   numSelected={selected.length}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    // .slice(page * 5, page * 5 + 5)
                                    .map((m, i) => {
                                        return (
                                            <ContractorTableRow divisionId={cafeteriaId} key={m.ID} rowData={m} handleRequestSort={handleRequestSort} order={order} orderBy={orderBy} />
                                        )
                                    })}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(tableData?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default ContractorManagementTable;